import { BrowserRouter, Routes, Route } from "react-router-dom";
import './App.css';
import Homepage from './pages/homepage/Homepage';
import Register from './pages/Register/Register';
import Login from './pages/Login/Login';
import Dashboard from './pages/Dashboard/Dashboard';
import FormBuilder from './pages/Workspace/FormBuilder';
import Formbots from './pages/Formbots/Formbots';

function App() {
  return (
    <BrowserRouter>
    <Routes>
      <Route path="/" element={<Homepage />} />
      <Route path="/register" element={<Register />} />
      <Route path="/login" element={<Login />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/formbuilder/:folderName/:formid11" element={<FormBuilder />} />
      <Route path="/formbots/:id" element={<Formbots />} />
     
    </Routes>
  </BrowserRouter>
   
  )
}

export default App;
